import React from "react";
import { Navigate } from "react-router-dom";
import { doDemoModeOnOff, getDemoMode } from "../../helpers";
export function DemoOffPage() {
  doDemoModeOnOff();
  return <Navigate to="/dashboard" replace />;
}
